// Purpose: Decode JWT from localStorage with structural validation and expiration check
// Caller: ProtectedRoute, DashboardPage, App.js, AuthenticatedNavbar
// Dependencies: jsonwebtoken
// Main Functions: getUser
// Side Effects: Clears invalid/expired tokens from localStorage

import jwt from "jsonwebtoken";

const isValidToken = (decoded) => {
  if (!decoded || typeof decoded !== "object") return false;
  if (!decoded.user) return false;
  if (decoded.exp && decoded.exp < Date.now() / 1000) return false;
  return true;
};

export const getUser = () => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return "";

    const parts = accessToken.split(".");
    if (parts.length !== 3) {
      localStorage.removeItem("accessToken");
      return "";
    }

    const decoded = jwt.decode(accessToken);
    if (!isValidToken(decoded)) {
      localStorage.removeItem("accessToken");
      return "";
    }

    return decoded.user;
  } catch {
    localStorage.removeItem("accessToken");
    return "";
  }
};
